import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { withFormik } from 'formik'

import Field from '../../views/widgets/Field'
import InputText from '../../views/widgets/InputText'
import withPortalAutoRemoteSync from '../../../modules/common/withPortalAutoRemoteSync'
import config from '../../../config'
import withValidateBeforeSync from '../../../modules/common/withValidateBeforeSync'

const GeneralInfoContactForm = ({
  language,
  values,
  touched,
  errors,
  isSubmitting,
  handleChange,
  handleBlur,
  handleAutoSyncOnBlur,
  handleSubmit,
  handleReset,
  dirty,
}) => (
  <div>
    <Field label="อีเมล์">
      <InputText
        name={`email`}
        placeholder="Enter your Email"
        onChange={handleChange}
        onBlur={handleAutoSyncOnBlur}
        value={values.email}
        error={errors.email && errors.email[language]}
      />
    </Field>
    <Field label="เบอร์โทรศัพท์">
      <InputText
        name={`phone`}
        placeholder="Enter your Phone"
        onChange={handleChange}
        onBlur={handleAutoSyncOnBlur}
        value={values.phone}
      />
    </Field>
    <Field label="เฟสบุคแฟนเพจ">
      <InputText
        name={`fanpage`}
        placeholder="Enter your Fanpage"
        onChange={handleChange}
        onBlur={handleAutoSyncOnBlur}
        value={values.fanpage}
      />
    </Field>
    <Field label="อินสตาแกรม">
      <InputText
        name={`instragramId`}
        placeholder="Enter your instragramId"
        onChange={handleChange}
        onBlur={handleAutoSyncOnBlur}
        value={values.instragramId}
      />
    </Field>
    <Field label="ไลน์ไอดี">
      <InputText
        name={`lineId`}
        placeholder="Enter your lineId"
        onChange={handleChange}
        onBlur={handleAutoSyncOnBlur}
        value={values.lineId}
      />
    </Field>
    <Field label="เว็บ">
      <InputText
        name={`webpage`}
        placeholder="Enter your webpage"
        onChange={handleChange}
        onBlur={handleAutoSyncOnBlur}
        value={values.webpage}
      />
    </Field>
    <Field label="อื่นๆ">
      <InputText
        name={`others.${language}`}
        placeholder="Enter your Others"
        onChange={handleChange}
        onBlur={handleAutoSyncOnBlur}
        value={values.others[language]}
      />
    </Field>
  </div>
)

const initialContact = contacts => ({
  email: '',
  phone: '',
  fanpage: '',
  instragramId: '',
  lineId: '',
  webpage: '',
  others: config.getLangText(),
  ...contacts,
})

const validateContact = (values, language) => {
  let errors = {}

  if (values.email && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    errors.email = { th: 'รูปแบบ email ไม่ถูกต้อง' }
  }

  return errors
}

export default compose(
  connect(({ portal, info: { language } }) => ({ portal, language })),
  withFormik({
    mapPropsToValues: ({ portal: { contacts } }) => {
      return initialContact(contacts)
    },
    validate: validateContact,
    enableReinitialize: true,
    displayName: 'Contact', // helps with React DevTools
  }),
  withPortalAutoRemoteSync(props => ({ path: `contacts` })),
  withValidateBeforeSync({
    validate: validateContact, // validate for sync
  }),
)(GeneralInfoContactForm)



// WEBPACK FOOTER //
// ./src/components/templates/general-info/GeneralInfoFormContact.js